import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: [],
  providers: []
})
export class ASFCoreModule { 
//  /*
//   * This module providers root services
//   */
//   static forRoot(data:any) {
//     return {
//       NgModule: ASFCoreModule,
//       providers: [
//       ]
//     }
//   }
}


